import React, { useEffect, useState } from 'react';
import { LICENSING_LABEL, MORE_INFO } from '../data/Localization';

/**
 * Renders a component that displays product toggle information.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Array} props.products - The array of products.
 * @returns {JSX.Element|null} The rendered component.
 */
const ProductToggleInfo = (props) => {
	const { products } = props;

	const [firstRenewalLabel, setFirstRenewalLabel] = useState(null);
	const [firstRenewalInfo, setFirstRenewalInfo] = useState(null);
	const [secondRenewalLabel, setSecondRenewalLabel] = useState(null);
	const [secondRenewalInfo, setSecondRenewalInfo] = useState(null);
	const [isOpen, setIsOpen] = useState(false);

	/**
	 * Toggles the view of more information.
	 *
	 * @param {Object} e - The event object.
	 */
	const handleToggleViewMoreInfo = (e) => {
		e.stopPropagation();
		setIsOpen(!isOpen);
	}

	/**
	 * Closes the more information view.
	 */
	const handleCloseMoreInfo = () => {
		if (!isOpen) return;
		setIsOpen(false);
	}

	useEffect(() => {
		let _firstRenewalLabel;
		products?.forEach((prod) => {
			if (!_firstRenewalLabel && prod.moreInfo === 'true') {
				_firstRenewalLabel = `${MORE_INFO.topLabel}`;
				setFirstRenewalLabel(_firstRenewalLabel);
				setFirstRenewalInfo(`${MORE_INFO.topText}`);
			} else if (prod.moreInfo === 'true') {
				setSecondRenewalLabel(`${MORE_INFO.bottomLabel}`);
				setSecondRenewalInfo(`${MORE_INFO.bottomText}`);
			}
		});
	}, [products]);

	if (firstRenewalInfo == null && secondRenewalInfo == null) {
		return null; // no renewal labels
	}

	if (products.length < 2) {
		return null;
	}

	return (
		<div className="prc__card--cta-more-info">
			<span className="more-info-tip" data-testid="more-info-tip" onClick={handleToggleViewMoreInfo}></span>
			<div className="more-info-content" data-testid="more-info-content" aria-hidden={!isOpen}>
				<div className="more-info-close-button" data-testid="more-info-close" onClick={handleCloseMoreInfo}></div>
				<h3 className="more-info-content-heading font-size-1 avenir-medium">{LICENSING_LABEL}</h3>
				{firstRenewalInfo && (
					<>
						<h4 className="more-info-section-heading font-size--1 avenir-demi">{firstRenewalLabel}</h4>
						<p className="trailer-half more-info-description">{firstRenewalInfo}</p>
					</>
				)}
				{secondRenewalInfo && (
					<>
						<h4 className="more-info-section-heading font-size--1 avenir-demi">{secondRenewalLabel}</h4>
						<p className="trailer-0 more-info-description">{secondRenewalInfo}</p>
					</>
				)}
			</div>
		</div>
	);
};

export default ProductToggleInfo;
